import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import OffersService from '~/services/OffersService';

export const offerQueryKeys = {
  all: ['offers'] as const,
  details: () => [...offerQueryKeys.all, 'detail'] as const,
  detail: (id: string) => [...offerQueryKeys.details(), id] as const,
};

export function useGetOffer(offerId: string | undefined) {
  return useQuery({
    queryKey: offerQueryKeys.detail(offerId),
    queryFn: async () => {
      const response = await OffersService.getOffer(offerId);
      return response.result;
    },
    enabled: !!offerId,
  });
}

export function useGetOfferSchema(offerId: string | undefined) {
  return useQuery({
    queryKey: [...offerQueryKeys.detail(offerId), 'schema'],
    queryFn: async () => {
      const response = await OffersService.getOfferSchema(offerId);
      return response.patch.body.schema;
    },
    enabled: !!offerId,
  });
}

export interface StructuredFinePrint {
  cancellation_text: string;
  date_changes_text: string;
  inclusion_notes: string;
  fine_print: string;
}

export function useUpdateStructuredFinePrint(offerId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: StructuredFinePrint) => {
      return OffersService.updateOffer({ structured_fine_print: data }, offerId);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: offerQueryKeys.detail(offerId) });
    },
  });
}
